<template>
  <div class="hitchRideWithdrawalRule">
    <custom-org-tree ref="customTree" @selected="handleSelect" url="/api/v1/manage/hitchRide/withdrawalConfig"/>

    <div class="hitchRideWithdrawalRule-content">
      <driverWithdrawal :rowData="{ ...selectCity }" @refresh="refresh"></driverWithdrawal>
    </div>
  </div>
</template>

<script>
import CustomOrgTree from './components/CustomOrgTree.vue';
import driverWithdrawal from './components/driverWithdrawal.vue'

export default {
  components: {CustomOrgTree, driverWithdrawal},
  data() {
    return {
      selectCity: {}
    };
  },
  computed: {},
  created() {

  },
  methods: {
    handleSelect(node) {
      this.selectCity = node;
    },
    refresh() {
      this.$refs.customTree.getOrgData(true);
    }

  }
};
</script>

<style lang="less" scoped>
.hitchRideWithdrawalRule {
  display: flex;

  &-content {
    padding: 16px;
    flex: 1;
    max-height: calc(100vh - 240px);
    overflow-y: auto;
  }
}
</style>
